{
  "mappings": [
    {
      "category": "Personal details",
      "titles": ["ACCOUNT", "AccountDetails.csv", "Additional Information.pdf"]
    },
    {
      "category": "Payment details",
      "titles": ["BillingHistory.csv", "PAYMENT_AND_BILLING", "SubscriptionHistory.csv"]
    },
    {
      "category": "Purchase information",
      "titles": ["no_matching_file"]
    },
    {
      "category": "Netflix account/profile information",
      "titles": [
        "AvatarHistory.csv",
        "GAMES",
        "GamePlaySession.txt",
        "MyList.csv",
        "ParentalControlsRestrictedTitles.txt",
        "PlaybackRelatedEvents.csv",
        "Profiles.csv",
        "Ratings.txt",
        "ViewingActivity.csv"
      ]
    },
    {
      "category": "Usage information",
      "titles": [
        "CLICKSTREAM",
        "CONTENT_INTERACTION",
        "Clickstream.csv",
        "GamePlaySession.txt",
        "IndicatedPreferences.csv",
        "PlaybackRelatedEvents.csv",
        "SearchHistory.csv",
        "ViewingActivity.csv"
      ]
    },
    {
      "category": "Advertising information",
      "titles": ["IP_ADDRESSES", "IpAddressesAccountCreation.csv", "IpAddressesLogin.txt", "IpAddressesStreaming.csv"]
    },
    {
      "category": "Device and network information",
      "titles": ["AccessAndDevices.csv", "DEVICES", "Devices.csv"]
    },
    {
      "category": "Communications",
      "titles": [
        "CSContact.txt",
        "CUSTOMER_SERVICE",
        "ChatTranscripts.txt",
        "MessagesSentByNetflix.csv",
        "ProductCancellationSurvey.txt"
      ]
    }
  ]
}
